/**
 * 普通网站登录入口：跳转本站 /login 桥接页，由 browser-session 完成账号中心登录。
 */
export function buildSsoLoginUrl(returnPath = '/') {
  const path = typeof returnPath === 'string'
    && returnPath.startsWith('/')
    && !returnPath.startsWith('//')
    ? returnPath
    : '/'
  if (path === '/') return '/login'
  return `/login?return_to=${encodeURIComponent(path)}`
}
